import React from "react";

interface FormHeaderProps {
  title?: string;
  subtitle?: string;
  stepTitle?: string;
  characterImage?: string;
  characterAlt?: string;
  className?: string;
}

export function FormHeader({
  title,
  subtitle,
  stepTitle,
  characterImage,
  characterAlt = "Personagem",
  className = "",
}: FormHeaderProps) {
  return (
    <div className={`flex flex-col lg:flex-row items-start lg:justify-between mb-6 sm:mb-7 lg:mb-8 relative ${className}`}>
      <div className="w-full lg:max-w-lg">
        {title && (
          <h2 className="text-xl sm:text-2xl md:text-2xl lg:text-3xl xl:text-4xl text-green-bb-2 font-bold mb-4 sm:mb-6 lg:mb-8">
            {subtitle ? (
              <>
                {title} <span className="text-blue-bb-1">{subtitle}</span>
               
              </>
            ) : (
              title
            )}
          </h2>
        )}

        {stepTitle && (
          <h2 className="text-lg sm:text-xl md:text-xl lg:text-xl font-bold text-gray-bb-1 mb-4 sm:mb-5 lg:mb-6">
            {stepTitle}
          </h2>
        )}
      </div>
      {characterImage && (
        <img
          src={characterImage}
          alt={characterAlt}
          className="hidden lg:block absolute right-0 top-0 h-auto z-10"
          style={{ transform: "translateY(20px)" }}
          loading="lazy"
          decoding="async"
        />
      )}
    </div>
  );
}